// Section 18: Health care policy, the triage order for healer time and medicine (Section 12;
// Section 17 "medicine and healer time use the health-care policy"). The bodies phase applies it
// (phases/bodies/healing.ts); the player's marks by name (`triageOverrides`) come first under any
// option. The preview names how many are sick or injured, how many healers saw last season, and
// how many the option puts first. Default: config.policies.defaults.healthCare.
import type { Config } from '../../config';
import { noChangeCost, noProblem } from '../../core/content-helpers';
import { isChild, lastCompletedReport, peopleSorted } from '../../core/queries';
import { definePolicy, noModifiers } from '../../core/registry';
import type { PreviewLine } from '../../core/types';

export function healthCare(config: Config) {
  return definePolicy({
    id: 'healthCare',
    label: 'Health care',
    section: 'S18',
    group: 'health',
    options: [
      'most-likely-to-die',
      'contagious-first',
      'workers-first',
      'children-first',
      'manual',
    ],
    default: config.policies.defaults.healthCare,
    modifierTargets: [],
    modifiers: noModifiers,
    changeCost: noChangeCost,
    affects(ctx, option) {
      const patients = peopleSorted(ctx.state).filter(
        (p) => p.status.sick !== null || p.status.injured !== null,
      );
      const slots = lastCompletedReport(ctx.state)?.services.healingSlots ?? 0;
      const lines: PreviewLine[] = [
        {
          key: 'policy.healthCare.patients',
          params: { patients: patients.length, capacity: Math.floor(slots + 1e-9) },
        },
      ];
      if (patients.length === 0) return lines;
      const first = patients.filter((p) => {
        switch (option) {
          case 'contagious-first':
            return (
              p.status.sick !== null && config.illnesses[p.status.sick.illnessId].contagion > 0
            );
          case 'workers-first':
            return p.job !== 'rest';
          case 'children-first':
            return isChild(config, p);
          case 'manual':
            return ctx.state.triageOverrides[p.id] === true;
          case 'most-likely-to-die':
            return false;
        }
      }).length;
      if (option !== 'most-likely-to-die')
        lines.push({ key: `policy.healthCare.first.${option}`, params: { count: first } });
      return lines;
    },
    validate: noProblem,
  });
}
